import { h, Component } from 'preact'
import InputGroup from '../ui-components/InputGroup'
import { Modal, ModalBody, ModalFooter, ModalHeader } from '../modal'
import ButtonControl from '../button-control'

interface ModalState {
  newName: string,
  id?: string,
  error?: string
}

interface ModalProps {
  productArea?: string,
  id?: string,
  error?: string,
  onSave: (newValue: string, id?: string) => void,
  onClose: () => void,
  onClick: () => void
}

export class EditModal extends Component<ModalProps, ModalState> {
  constructor (props: ModalProps) {
    super(props)
    this.state = {
      newName: props.productArea || '',
      id: props.id || ''
    }
  }

  render ({ productArea, onSave, onClose, onClick, error }: ModalProps, { newName, id }: ModalState) {
    return <Modal isOpen size='medium'>
      <ModalHeader title={productArea ? `Edit product area '${productArea}'` : 'New product area'} onClose={onClose} />
      <ModalBody>
        <InputGroup title='Product area'
          placeholder='Add product area name'
          qaClasses='qa-add-product-area-input'
          value={newName}
          onChange={(e: ChangeEvent) => this.setState({ newName: e.target.value })}
          onClick={onClick}
          error={error}
        />

      </ModalBody>
      <ModalFooter>
        <ButtonControl
          class='qa-public-product-area-save'
          title='Save changes'
          variant='success'
          onClick={() => onSave(newName, id)} />
        <ButtonControl
          class='qa-public-product-area-cancel'
          title='Cancel'
          onClick={onClose} />
      </ModalFooter>
    </Modal>
  }
}

interface DeleteModalProps {
  productArea: string,
  id: string,
  onDelete: (id: string) => void,
  onClose: () => void
}

export const DeleteModal = ({ productArea, id, onDelete, onClose }: DeleteModalProps) => <Modal isOpen size='medium'>
  <ModalHeader title={`Delete product area '${productArea}'?`} onClose={onClose} />
  <ModalBody>There is no undo. Once deleted, this product area will be removed from all related topics.</ModalBody>
  <ModalFooter>
    <ButtonControl
      title='Delete'
      class='qa-public-product-area-delete'
      variant='danger'
      onClick={() => onDelete(id)} />
    <ButtonControl
      title='Cancel'
      class='qa-public-product-area-cancel'
      onClick={onClose} />
  </ModalFooter>
</Modal>
